module.exports = __webpack_public_path__ + "img/card-bg-02.6ebf0112.png";